import { useQuery } from "@tanstack/react-query";
import { phasesKeys } from "@/application/query-keys/phases.keys";
import { phasesRepository } from "@/infrastructure/repositories/phases.supabase.repository";

export function usePhasesList() {
  return useQuery({
    queryKey: phasesKeys.list(),
    queryFn: () => phasesRepository.list(),
  });
}

export function useCurrentPhase() {
  return useQuery({
    queryKey: phasesKeys.current(),
    queryFn: () => phasesRepository.current(),
  });
}
